import { Flex, reactIcons, Typography } from '@project44/manifest-ds';
import { DateFormat, formatDateTime } from '@project44/ui-utils';

import { CloseButton, Content } from './styles';

interface PopupProps {
  dateTime: string;
  coordinates: [number, number];
  onClose: () => void;
}

const dateFormat = DateFormat.monthDayYearHourMinuteAbbreviatedTimezone;

export const Popup = ({ dateTime, coordinates, onClose }: PopupProps) => {
  const [long, lat] = coordinates;

  const title = formatDateTime({ dateTime, dateFormat });
  const body = `${lat.toFixed(3)}, ${long.toFixed(3)}`;

  return (
    <Flex data-testid="map-popup-content">
      <Content>
        <Flex orientation="vertical" gap="x-small">
          <Typography variant="subtextBold">{title}</Typography>
          <Typography variant="caption">{body}</Typography>
        </Flex>
      </Content>
      <CloseButton onClick={onClose} data-testid="map-popup-close">
        <reactIcons.Close size="medium" />
      </CloseButton>
    </Flex>
  );
};
